module.exports = __webpack_public_path__ + "statics/img/sn-oem.a4cb4018.svg";